<template>
  <div class="animated fadeIn" id="list-sirens">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche Base Relation Client</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened"><i class="icon-arrow-down"></i></span>
              <span class="when-closed"><i class="icon-arrow-up"></i></span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="search">
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="date_appel_du"><strong>Date sollicitation client</strong></label>
                    <b-row>
                      <b-col sm="4">
                        <b-form-input class="input_date" type="date" id="date_appel_du" v-model="date_appel_du"></b-form-input>
                      </b-col>
                      <b-col sm="2">
                        <label for="date_appel_au"><strong>au :</strong></label>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input class="input_date" type="date" id="date_appel_au" v-model="date_appel_au"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="numero_fiche"><strong>N° de Fiche</strong></label>
                    <b-form-input type="text" id="numero_fiche" v-model="numero_fiche"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="criticite"><strong>Criticité</strong></label>
                    <b-row>
                      <b-col sm="4">
                        <b-form-select v-model="criticite">
                          <b-form-select-option value="S">Standard</b-form-select-option>
                          <b-form-select-option value="R">Réclamation</b-form-select-option>
                          <b-form-select-option value="U">Urgent</b-form-select-option>
                          <b-form-select-option :value="''">-- Sélectionner --</b-form-select-option>
                        </b-form-select>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="nom_contact"><strong>Nom du Contact</strong></label>
                    <b-form-input type="text" id="nom_contact" v-model="nom_contact"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="tel_contact"><strong>N° Tél du Contact</strong></label>
                    <b-form-input type="text" id="tel_contact" v-model="tel_contact"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="mail_contact"><strong>Email du Contact</strong></label>
                    <b-form-input type="text" id="mail_contact" v-model="mail_contact"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="raison_sociale"><strong>RS Employeur</strong></label>
                    <b-form-input type="text" id="raison_sociale" v-model="raison_sociale"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="siren"><strong>SIREN / SIRET</strong></label>
                    <b-row>
                      <b-col sm="4">
                        <b-form-input placeholder="SIREN" type="text" id="structure_siren" v-model="structure_siren"></b-form-input>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input placeholder="NIC" type="text" id="structure_nic" v-model="structure_nic"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="nom_beneficiaire"><strong>Nom Ass./Bénéf.</strong></label>
                    <b-form-input type="text" id="nom_beneficiaire" v-model="nom_beneficiaire"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="prenom_beneficiaire"><strong>Prénom Ass./Bénéf.</strong></label>
                    <b-form-input type="text" id="prenom_beneficiaire" v-model="prenom_beneficiaire"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="nir_assure"><strong>N° SS de l'Assuré</strong></label>
                    <b-row>
                      <b-col sm="4">
                        <b-form-input placeholder="NIR" type="text" id="nir_beneficiaire" v-model="nir_beneficiaire"></b-form-input>
                      </b-col>
                      <b-col sm="4">
                        <b-form-input placeholder="Clé" type="text" id="nir_cle" v-model="nir_cle"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="produit"><strong>Gamme Produit</strong></label>
                      <span>
                        <b-form-select ref="gammeSelect"
                              id="basicSelect"
                              :plain="true"
                              :options="produitOptions"
                              v-model="produit">
                          <template #first>
                            <b-form-select-option :value="''">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                      </span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="garantie"><strong>Garantie</strong></label>
                      <span>
                        <b-form-select ref="garantieSelect"
                              id="garantieSelect"
                              :plain="true"
                              :options="garantieOptions"
                              v-model="garantie">
                          <template #first>
                            <b-form-select-option :value="''">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                      </span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="status"><strong>Statut</strong></label>
                      <span>
                        <b-form-select ref="statusSelect"
                              id="statusSelect"
                              :plain="true"
                              :options="statusOptions"
                              v-model="status">
                          <template #first>
                            <b-form-select-option :value="''">-- Sélectionner --</b-form-select-option>
                          </template>
                        </b-form-select>
                      </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="createur"><strong>Créateur Fiche</strong></label>
                    <!-- <b-form-input type="text" id="createur" v-model="createur"></b-form-input> -->
                    <auto-select
                      v-model="createur"
                      :items="createurs"
                      :loading="loadingCreateur"
                      item-value="id"
                      item-text="nom"
                      id="createur"
                      :placeholder="createur ? '' : 'Entrer le nom du gestionnaire'"
                      disable-filtering-by-search
                      @search="onSearchCreateur"
                      v-on:keyup.enter="onEnterCreateur()"
                    >
                      <template #no-data>
                        {{ noDataCreateur ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
                      </template>
                      <template slot="item" slot-scope="{ item: gest }">
                        <div style="display: flex; align-items: center;" @click="onClickCreateur($event, gest)">
                          <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                        </div>
                      </template>
                      <template slot="selection" slot-scope="{ item: gest }">
                        <div style="display: flex; align-items: center;">
                          <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                        </div>
                      </template>
                      <template v-if="loadingCreateur" #input-end>
                        <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                      </template>
                    </auto-select>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="destinataire_libelle"><strong>B.O. en charge</strong></label>
                    <b-form-input type="text" id="destinataire_libelle" v-model="destinataire_libelle"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="gestionnaire"><strong>Gestionnaire en charge</strong></label>
                    <!-- <b-form-input type="text" id="gestionnaire" v-model="gestionnaire"></b-form-input> -->
                    <auto-select
                      v-model="gestionnaire"
                      :items="gestionnaires"
                      :loading="loadingGestionnaire"
                      item-value="id"
                      item-text="nom"
                      id="gestionnaire"
                      :placeholder="gestionnaire ? '' : 'Entrer le nom du gestionnaire'"
                      disable-filtering-by-search
                      @search="onSearchGestionnaire"
                      v-on:keyup.enter="onEnter()"
                    >
                      <template #no-data>
                        {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
                      </template>
                      <template slot="item" slot-scope="{ item: gest }">
                        <div style="display: flex; align-items: center;" @click="onClick($event, gest)">
                          <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                        </div>
                      </template>
                      <template slot="selection" slot-scope="{ item: gest }">
                        <div style="display: flex; align-items: center;">
                          <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
                        </div>
                      </template>
                      <template v-if="loadingGestionnaire" #input-end>
                        <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
                      </template>
                    </auto-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click.prevent="search()" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des Fiches</strong>
      </b-card-header>
      <b-card-body>
        <fiches-table :tableEntry="tableParam" ref="fiches_table"></fiches-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
  import FichesTable from '@/components/FichesTable'
  import { CoolSelect as AutoSelect } from 'vue-cool-select'
  import {isEmpty} from "@/utils/fileHelper"

  export default {
    name: "Recherche",
    components: { FichesTable, AutoSelect },
    data() {
      return {
        date_appel_du: '',
        date_appel_au: '',
        numero_fiche: '',
        criticite: '',
        nom_contact: '',
        tel_contact: '',
        mail_contact: '',
        raison_sociale: '',
        structure_siren: '',
        structure_nic: '',
        nom_beneficiaire: '',
        prenom_beneficiaire: '',
        nir_beneficiaire: '',
        nir_cle: '',
        produit: '',
        produitOptions: [],
        garantieOptions: ['IJ','Inval','Décès'],
        garantie: '',
        status: '',
        statusOptions : [],
        createur: '',
        createurNom: '',
        createurPrenom: '',
        createurs: [],
        loadingCreateur: false,
        timeoutCreateurId: null,
        noDataCreateur: false,
        destinataire_libelle: '',
        noSearch: 'noSearch',
        gestionnaire: '',
        gestionnaireNom: '',
        gestionnairePrenom: '',
        gestionnaires: [],
        loadingGestionnaire: false,
        timeoutId: null,
        noData: false,
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()
      this.getGammeProduits()
      this.getStatus()

      if (this.$route.query.dad) {
        this.date_appel_du = this.$route.query.dad
      }
      if (this.$route.query.daa) {
        this.date_appel_au = this.$route.query.daa
      }
      if (this.$route.query.nf) {
        this.numero_fiche = this.$route.query.nf
      }
      if (this.$route.query.criticite) {
        this.criticite = this.$route.query.criticite
      }
      if (this.$route.query.nc) {
        this.nom_contact = this.$route.query.nc
      }
      if (this.$route.query.tc) {
        this.tel_contact = this.$route.query.tc
      }
      if (this.$route.query.mc) {
        this.mail_contact = this.$route.query.mc
      }
      if (this.$route.query.rs) {
        this.raison_sociale = this.$route.query.rs
      }
      if (this.$route.query.siren) {
        this.structure_siren = this.$route.query.siren
      }
      if (this.$route.query.nic) {
        this.structure_nic = this.$route.query.nic
      }
      if (this.$route.query.nb) {
        this.nom_beneficiaire = this.$route.query.nb
      }
      if (this.$route.query.pb) {
        this.prenom_beneficiaire = this.$route.query.pb
      }
      if (this.$route.query.nirb) {
        this.nir_beneficiaire = this.$route.query.nirb
      }
      if (this.$route.query.nircle) {
        this.nir_cle = this.$route.query.nircle
      }
      if (this.$route.query.produit) {
        this.produit = this.$route.query.produit
      }
      if (this.$route.query.garantie) {
        this.garantie = this.$route.query.garantie
      }
      if (this.$route.query.status) {
        this.status = this.$route.query.status
      }
      if (this.$route.query.createur) {
        this.createur = this.$route.query.createur
      }
      if (this.$route.query.dl) {
        this.destinataire_libelle = this.$route.query.dl
      }
      if (this.$route.query.gest) {
        this.gestionnaire = this.$route.query.gest
      }
      // Si co alors retour d'une fiche suite à recherche, donc noSearch vide
      if (this.$route.query.noSearch) {
        this.noSearch = ''
      }
    },
    computed: {
      tableParam: {
        get() {
          let request = {}
          request.date_appel_du = this.date_appel_du
          request.date_appel_au = this.date_appel_au
          request.numero_fiche = this.numero_fiche
          request.criticite = this.criticite
          request.nom_contact = this.nom_contact
          request.tel_contact = this.tel_contact
          request.mail_contact = this.mail_contact
          request.raison_sociale = this.raison_sociale
          request.structure_siren = this.structure_siren
          request.structure_nic = this.structure_nic
          request.nom_beneficiaire = this.nom_beneficiaire
          request.prenom_beneficiaire = this.prenom_beneficiaire
          request.nir_beneficiaire = this.nir_beneficiaire
          request.nir_cle = this.nir_cle
          request.produit = this.produit
          request.garantie = this.garantie
          request.status = this.status
          request.createur = isEmpty(this.createur) ? '' : this.createur
          request.destinataire_libelle = this.destinataire_libelle
          request.gestionnaire = isEmpty(this.gestionnaire) ? '' : this.gestionnaire
          request.noSearch = this.noSearch
          return request
        }
      },
    },
    methods: {
      onClick(event, item){
        this.gestionnaireNom = item.nom
        this.gestionnairePrenom = item.prenom
      },
      onEnter(){
        for(let gest of this.gestionnaires) {
          if (this.gestionnaire === gest.id) {
            this.gestionnaireNom = gest.nom
            this.gestionnairePrenom = gest.prenom
          }
        }
      },
      async onSearchGestionnaire(search) {
        let self = this
        const lettersLimit = 2

        this.noData = false
        if (search.length < lettersLimit) {
          this.gestionnaires = []
          this.loadingGestionnaire = false
          return
        }
        this.loadingGestionnaire = true

        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get('/espaceGestion/gestionnaire/autocompleteRecherche?query='+search+'&type=all&for=rc')
            .then(response => {
              // console.log(response)
              this.loadingGestionnaire = false
              this.gestionnaires = response.data
              if (!this.gestionnaires.length) this.noData = true
            })
            .catch(function(error) {
              console.log(error)
              self.loadingGestionnaire = false
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }, 500)
      },
      onClickCreateur(event, item){
        this.createurNom = item.nom
        this.createurPrenom = item.prenom
      },
      onEnterCreateur(){
        for(let gest of this.createurs) {
          if (this.createur === gest.id) {
            this.createurNom = gest.nom
            this.createurPrenom = gest.prenom
          }
        }
      },
      async onSearchCreateur(search) {
        let self = this
        const lettersLimit = 2

        this.noDataCreateur = false
        if (search.length < lettersLimit) {
          this.createurs = []
          this.loadingCreateur = false
          return
        }
        this.loadingCreateur = true

        clearTimeout(this.timeoutCreateurId)
        this.timeoutCreateurId = setTimeout(async () => {
          this.$axios
            .get('/espaceGestion/gestionnaire/autocompleteRecherche?query='+search+'&type=all&for=rc')
            .then(response => {
              // console.log(response)
              this.loadingCreateur = false
              this.createurs = response.data
              if (!this.createurs.length) this.noDataCreateur = true
            })
            .catch(function(error) {
              console.log(error)
              self.loadingCreateur = false
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }, 500)
      },
      getGammeProduits() {
        this.produitOptions = [];
        let self = this;
        this.$axios
          .get('/espaceRelationClient/fiche-niv2/produits')
          .then(response => {
            for (let row of response.data.produits) {
              this.produitOptions.push({text: row.libelle, value: row.id});
              console.log('row',row);
            }
            console.log(this.produitOptions);
          })
          .catch(function(error) {
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des produits. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      getStatus() {
        this.statusOptions = [];
        let self = this;
        this.$axios
          .get('/espaceRelationClient/fiche-niv2/status')
          .then(response => {
            const allStatus = response.data.status;
            this.allStatus = allStatus;
            this.statusOptions.push({value: '', text: 'Tous'});
            for (let key in allStatus) {
              this.statusOptions.push({value: allStatus[key].id, text: allStatus[key].libelle_bo});
            }
          })
          .catch(function(error) {
            self.$swal({
                position: "top",
                type: "warning",
                title: "Attention !!",
                text: 'Une erreur est survenue pendant la récupération des status. Si le problème persiste contactez le support DOSI.',
                showConfirmButton: false,
                timer: 5000
              })
          })
      },
      search() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          this.noSearch = '';
          setTimeout(this.$refs.fiches_table.$refs.table.refresh(), 3000);
        }
      },
      validateData() {
        return true
      },
      clearForm() {
        this.date_appel_du = ''
        this.date_appel_au = ''
        this.numero_fiche = ''
        this.criticite = ''
        this.nom_contact = ''
        this.tel_contact = ''
        this.mail_contact = ''
        this.raison_sociale = ''
        this.structure_siren = ''
        this.structure_nic = ''
        this.nom_beneficiaire = ''
        this.prenom_beneficiaire = ''
        this.nir_beneficiaire = ''
        this.nir_cle = ''
        this.gammeSelect = null
        this.garantieSelect = null
        this.statusSelect = null
        // this.createurs = []
        this.createur = ''
        this.createurNom = ''
        this.createurPrenom = ''
        // this.gestionnaires = []
        this.gestionnaire = ''
        this.gestionnaireNom = ''
        this.gestionnairePrenom = ''
        this.destinataire_libelle = ''
        this.produit = ''
        this.garantie = ''
        this.status = ''
      }
    }
  };
</script>
